import { useEffect, useMemo, useState } from 'react';
import { Camera, ChevronLeft, ChevronRight, X } from 'lucide-react';
import { listHalloweenGallery } from '../lib/halloweenGalleryApi';
import './HalloweenSchoolGallery.css';

const EXISTING = [{
  id:'existing-school-photo',
  imageUrl:'/images/school-pumpkin-patch.jpg',
  title:'School pumpkin patch memories',
  description:'A glimpse of the school pumpkin patch experiences Jonny’s Towing creates for the community.',
  alt_text:'Jonny’s Towing school pumpkin patch installation with pumpkins and a themed Halloween display.',
  school_label:'School pumpkin event',
  event_year:null
}];
export default function HalloweenSchoolGallery() {
  const [items,setItems]=useState([]);
  const [loading,setLoading]=useState(true);
  const [message,setMessage]=useState('');
  const [year,setYear]=useState('all');
  const [selected,setSelected]=useState(-1);

  useEffect(()=>{
    let active=true;
    listHalloweenGallery().then(rows=>{
      if(active){setItems(rows);setLoading(false);}
    }).catch(()=>{
      if(active){setMessage('The latest gallery photos cannot be loaded right now.');setLoading(false);}
    });
    return()=>{active=false;};
  },[]);
  const gallery = items.length ? items : EXISTING;
  const years = useMemo(()=>[...new Set(gallery.map(x=>x.event_year).filter(Boolean))].sort((a,b)=>b-a),[gallery]);
  const visible = useMemo(()=>year==='all' ? gallery : gallery.filter(x=>String(x.event_year)===year),[year,gallery]);
  const active = selected>=0?visible[selected]:null;
  useEffect(()=>{
    if(!active)return;
    const key=(event)=>{
      if(event.key==='Escape')setSelected(-1);
      if(event.key==='ArrowLeft')setSelected(i=>(i+visible.length-1)%visible.length);
      if(event.key==='ArrowRight')setSelected(i=>(i+1)%visible.length);
    };
    window.addEventListener('keydown',key);
    return()=>window.removeEventListener('keydown',key);
  },[active,visible.length]);
  return <div className="jhSchoolGallery" aria-label="Photo gallery of Jonny's Towing school events">
    <div className="jhGalleryToolbar">
      <div><span className="jhEyebrow">The memories behind the mission</span>
        <h3>Real school moments.</h3><p>Our own community events, documented through photographs—not images from another attraction.</p></div>
      {years.length>1&&<label>Event year <select value={year} onChange={e=>{setYear(e.target.value);setSelected(-1);}}>
        <option value="all">All years</option>{years.map(value=><option value={value} key={value}>{value}</option>)}</select></label>}
    </div>
    {loading&&<p className="jhGalleryNote">Loading the school gallery…</p>}
    {!loading&&message&&<p className="jhGalleryNote" role="status">{message} Showing our existing school-event photograph.</p>}
    <div className="jhGalleryGrid">
      {visible.map((photo,i)=><button type="button" className="jhGalleryCard" key={photo.id} onClick={()=>setSelected(i)} aria-label={'Enlarge '+photo.title}>
        <img src={photo.imageUrl} alt={photo.alt_text} loading="lazy"/>
        <span className="jhGalleryCaption"><Camera size={16}/><span><strong>{photo.title}</strong><small>{[photo.school_label,photo.event_year].filter(Boolean).join(' · ')}</small></span></span>
      </button>)}
    </div>
    <p className="jhGalleryDisclaimer">Photographs in this gallery document our real events. The Halloween flatbed scene at the top of this page is original AI-created artwork.</p>
    {active&&<div className="jhGalleryLightbox" role="dialog" aria-modal="true" aria-label="School event photograph" onClick={()=>setSelected(-1)}>
      <div className="jhGalleryLightboxInner" onClick={event=>event.stopPropagation()}>
        <button type="button" className="jhGalleryClose" onClick={()=>setSelected(-1)} aria-label="Close photo"><X size={26}/></button>
        <img src={active.imageUrl} alt={active.alt_text}/>
        <div className="jhGalleryLightboxCaption"><div><strong>{active.title}</strong><p>{active.description||[active.school_label,active.event_year].filter(Boolean).join(' · ')}</p></div>
          {visible.length>1&&<div className="jhGalleryPaging"><button type="button" onClick={()=>setSelected(i=>(i+visible.length-1)%visible.length)} aria-label="Previous photo"><ChevronLeft/></button><span>{selected+1} / {visible.length}</span><button type="button" onClick={()=>setSelected(i=>(i+1)%visible.length)} aria-label="Next photo"><ChevronRight/></button></div>}
        </div>
      </div>
    </div>}
  </div>;
}